import { render, staticRenderFns } from "./PianificazioneViaggioArrivo.vue?vue&type=template&id=79ccedbd&scoped=true"
import script from "./PianificazioneViaggioArrivo.vue?vue&type=script&lang=js"
export * from "./PianificazioneViaggioArrivo.vue?vue&type=script&lang=js"
import style0 from "./PianificazioneViaggioArrivo.vue?vue&type=style&index=0&id=79ccedbd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79ccedbd",
  null
  
)

export default component.exports